var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMusic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 206,
    height: 240,
    viewBox: "0 0 206 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(0,0,0,0);}.b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H206V240H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M800.109,465.663a43.286,43.286,0,0,1-43.268,43.3h-.029A43.289,43.289,0,0,1,713.5,465.7v-.035a43.286,43.286,0,0,1,43.277-43.3h.028a43.308,43.308,0,0,1,21.65,5.95V348.654l-87.444,8.758v108.25a43.291,43.291,0,0,1-43.28,43.3h-.024a43.289,43.289,0,0,1-43.3-43.278v-.025a43.286,43.286,0,0,1,43.274-43.3h.023a43.281,43.281,0,0,1,21.65,5.95V314.109l131.053-13.964",
    transform: "translate(-599.413 -284.145)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMusic);
export default __webpack_public_path__ + "static/media/ic_music.0160103c2eca5c36b4ce97645c74544b.svg";
export { ForwardRef as ReactComponent };